function SimpleLoader(selector = '.page') {
  this.selector = selector;
  this.el = document.querySelector(this.selector);

  this.exceptions = function () {
    if (!(this.el instanceof HTMLElement)) {
      throw new Error(`Свойство el не является html элементом, el=${this.el}`);
    }
  };

  this.show = function () {
    const loaderHtml = document.createElement('div');
    loaderHtml.classList.add('loader-wrapper');
    loaderHtml.innerHTML = '<div class="loader-container"><span class="loader"></span></div>';
    const object = document.querySelector(this.selector);
    const loader = object.querySelector('.loader-wrapper');
    if (loader) {
      return;
    }
    object.append(loaderHtml);
    object.style.position = 'relative';
  };

  this.hide = function () {
    const object = document.querySelector(this.selector);
    const loader = object.querySelector('.loader-wrapper');
    object.style.position = '';
    loader.remove();
  };
}

window.SimpleLoader = SimpleLoader;
